import { getServer } from '~/lib/api'

const chinaCheckpoints: Record<
  number,
  { treeCount: number; energyAmount: number }
> = {
  1: { treeCount: 800, energyAmount: 100_000 },
  2: { treeCount: 1600, energyAmount: 200_000 },
  3: { treeCount: 3200, energyAmount: 400_000 },
  4: { treeCount: 4800, energyAmount: 600_000 },
}

const globalCheckpoints: Record<
  number,
  { treeCount: number; energyAmount: number }
> = {
  1: { treeCount: 2000, energyAmount: 250_000 },
  2: { treeCount: 4000, energyAmount: 500_000 },
  3: { treeCount: 8000, energyAmount: 1_000_000 },
  4: { treeCount: 12000, energyAmount: 1_500_000 },
}

export function getCheckpoints() {
  return getServer() === 'china' ? chinaCheckpoints : globalCheckpoints
}

export function getMaxEnergy() {
  return getCheckpoints()[4].energyAmount
}
